const TAB_COUNT_PREFIX = 'pilar-widget:tabs:'

/**
 * Contagem de abas abertas do widget para este tenant, em localStorage
 * (compartilhado entre todas as abas do mesmo site). Best-effort de
 * propósito: não existe API de navegador pra saber com certeza "sou a
 * última aba deste site aberta" — isso é uma aproximação via contador, não
 * uma garantia. Se falhar silenciosamente por qualquer motivo (localStorage
 * bloqueado, corrida entre abas fechando ao mesmo tempo), o pior caso é o
 * histórico só expirar pelo TTL normal de 7 dias em vez de encurtar na hora
 * — nunca fica preso pra sempre.
 */

function tabCountKey(tenantId: string): string {
  return TAB_COUNT_PREFIX + tenantId
}

export function registerTabOpen(tenantId: string): void {
  try {
    const key = tabCountKey(tenantId)
    const current = Number(localStorage.getItem(key) ?? '0')
    localStorage.setItem(key, String(current + 1))
  } catch {
    // sem contagem — ver nota acima.
  }
}

/** Devolve true se esta era a última aba (contador chegou a 0 ao decrementar). */
export function registerTabClosed(tenantId: string): boolean {
  try {
    const key = tabCountKey(tenantId)
    const current = Number(localStorage.getItem(key) ?? '1')
    const next = Math.max(0, current - 1)
    if (next === 0) {
      localStorage.removeItem(key)
      return true
    }
    localStorage.setItem(key, String(next))
    return false
  } catch {
    return false
  }
}
